import * as React from 'react';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import * as ReactGA from 'react-ga';
import { getNoBrand } from 'src';

// css
const confirmformstyle = require('./confirmform.css');

// Props
interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class PasswordForm extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  handleRememberMeChange = e => this.props.loggedinUser.setRememberMe(e.target.checked);
  handleLoginNameChange = e => this.props.loggedinUser.properties.setLoginName(e.target.value);
  handlePasswordChange = e => this.props.loggedinUser.properties.setPassword(e.target.value);
  handleSubmitForm = (e) => {
    ReactGA.event({
      category: 'Login',
      action: 'Login by code',
      label: 'Login by code'
    });
    e.preventDefault();
    this.props.loggedinUser.login('confirmlogin');
    return false;
  }

  render() {

    const noBrand = getNoBrand();
    const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
  
    let buttonClass;
    if (branding ==='tellit'){
      buttonClass = "LogIn_button_tellit";
    } else {
      buttonClass = "LogIn_button";
    }
    
    return (
      <div>
        <form onSubmit={this.handleSubmitForm} className="login_username_box">
          <fieldset>
            <fieldset className="form-group">
              <input
                className="form-control form-control-lg"
                type="text"
                placeholder="Kod"
                value={this.props.loggedinUser.properties.password}
                onChange={this.handlePasswordChange}
              />
            </fieldset>

            <h6 className="passWordError">{this.props.loggedinUser.properties.errors}</h6>

            <Button
              variant="raised"
              className={buttonClass}
              type="submit"
              disabled={false}
              fullWidth={true}
            >
              Logga in
            </Button>

          </fieldset>
        </form>
        <div className="login_forgotPassword_surf_box_confirm">
          <FormControlLabel
            control={
              <Switch
                checked={this.props.loggedinUser.isRememberMe}
                onChange={this.handleRememberMeChange}
              />
            }
            label="Kom ihåg mig"
          />
        </div>
        <div className="login_forgotPassword_surf_box_confirm">
          <a

            href={`/login`}
            onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.setLoginForm('initiatelogin');
              this.props.loggedinUser.login('initiatelogin');
              return false;
            }}
          >
            Skicka ny kod
          </a>
        </div>
      </div>
    );
  }
}  


// WEBPACK FOOTER //
// ./src/components/loginforms/ConfirmForm.tsx